import React from "react";
import TechnicalScopeForm from "../components/forms/TechnicalScopeForm";

const TechnicalScope: React.FC = () => {
  return (
   <>
   <TechnicalScopeForm />
   </>
  );
};

export default TechnicalScope;
